import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/50a967d5-5d01-4523-9c96-df639fd82f91";
export const REGISTER_URL = "https://a.ntrk2.com/dfac5dfb-2282-4ff1-833c-6bfb760fa387";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://topwinph.kzw2a.com/download?openExternalBrowser=1&id=bt0z62kd545otko";

export * from "./codes";
export * from "./context";
